import { t } from 'localization/utils/t';

const TP = 'search.enums.translations';

export const getConstructorCategoriesStrings = (text: string) => {
  if (typeof text !== 'string') {
    return text;
  }
  switch (text?.toLowerCase()) {
    case 'all':
      return t(`${TP}.all`, 'All');
    case 'available now':
      return t(`${TP}.availableNow`, 'Available Now');
    case 'brand':
      return t(`${TP}.brand`, 'Brand');
    case 'category':
      return t(`${TP}.category`, 'Category');
    case 'color':
      return t(`${TP}.color`, 'Color');
    case 'condition':
      return t(`${TP}.condition`, 'Condition');
    case 'gender':
      return t(`${TP}.gender`, 'Gender');
    case 'gift cards':
      return t(`${TP}.giftCards`, 'Gift Cards');
    case 'goat clean':
      return t(`${TP}.goatClean`, 'GOAT Clean');
    case 'infant':
      return t(`${TP}.infant`, 'Infant');
    case 'instant ship':
      return t(`${TP}.instantShip`, 'Instant Ship');
    case 'men':
      return t(`${TP}.men`, 'Men');
    case 'new':
      return t(`${TP}.new`, 'New');
    case 'new with defects':
      return t(`${TP}.newWithDefects`, 'New With Defects');
    case 'price':
      return t(`${TP}.price`, 'Price');
    case 'sale':
      return t(`${TP}.sale`, 'Sale');
    case 'size':
      return t(`${TP}.size`, 'Size');
    case 'sneakers':
      return t(`${TP}.sneakers`, 'Sneakers');
    case 'under retail':
      return t(`${TP}.underRetail`, 'Under Retail');
    case 'used':
      return t(`${TP}.used`, 'Used');
    case 'women':
      return t(`${TP}.women`, 'Women');
    case 'year':
      return t(`${TP}.year`, 'Year');
    case 'youth':
      return t(`${TP}.youth`, 'Youth');
    default:
      return text;
  }
};

export const getColorStrings = (color: string) => {
  if (!color || typeof color !== 'string') {
    return color;
  }
  switch (color?.toLowerCase()) {
    case 'white':
      return t(`${TP}.white`, 'White');
    case 'grey':
      return t(`${TP}.grey`, 'Grey');
    case 'black':
      return t(`${TP}.black`, 'Black');
    case 'green':
      return t(`${TP}.green`, 'Green');
    case 'teal':
      return t(`${TP}.teal`, 'Teal');
    case 'blue':
      return t(`${TP}.blue`, 'Blue');
    case 'purple':
      return t(`${TP}.purple`, 'Purple');
    case 'pink':
      return t(`${TP}.pink`, 'Pink');
    case 'red':
      return t(`${TP}.red`, 'Red');
    case 'orange':
      return t(`${TP}.orange`, 'Orange');
    case 'yellow':
      return t(`${TP}.yellow`, 'Yellow');
    case 'cream':
      return t(`${TP}.cream`, 'Cream');
    case 'tan':
      return t(`${TP}.tan`, 'Tan');
    case 'brown':
      return t(`${TP}.brown`, 'Brown');
    case 'silver':
      return t(`${TP}.silver`, 'Silver');
    case 'gold':
      return t(`${TP}.gold`, 'Gold');
    case 'copper':
      return t(`${TP}.copper`, 'Copper');
    case 'multi-color':
      return t(`${TP}.multiColor`, 'Multi-Color');
    default:
      return color;
  }
};

export const getConstructorSortStrings = (text: string) => {
  if (!text || typeof text !== 'string') {
    return text;
  }
  switch (text?.toLowerCase()) {
    case 'popular':
      return t(`${TP}.popular`, 'Popular');
    case 'recently released sneakers':
      return t(`${TP}.recentlyReleasedSneakers`, 'Recently Released Sneakers');
    case 'new in apparel':
      return t(`${TP}.newInApparel`, 'New In Apparel');
    case 'price (low - high)':
      return t(`${TP}.priceLowToHigh`, 'Price (Low - High)');
    case 'price (high - low)':
      return t(`${TP}.priceHighToLow`, 'Price (High - Low)');
    default:
      return text;
  }
};

export const getConstructorDescription = (text: string) => {
  if (!text || typeof text !== 'string') {
    return text;
  }
  switch (text?.toLowerCase()) {
    case 'new and never worn items':
      return t(`${TP}.newAndNeverWorn`, 'New and never worn items');
    case 'gently used or worn items':
      return t(`${TP}.gentlyUsedOrWorn`, 'Gently used or worn items');
    case 'new or unworn sneakers with imperfections':
      return t(`${TP}.newOrUnwornWithImperfections`, 'New or unworn sneakers with imperfections');
    case 'professionally cleaned & graded sneakers':
      return t(`${TP}.professionally`, 'Professionally cleaned & graded sneakers');
    case 'pre-verified and ships instantly':
      return t(`${TP}.preVerifiedAndShipInstanly`, 'Pre-verified and ships instantly');
    default:
      return text;
  }
};

export const getDateRangeStrings = (text: string) => {
  if (!text || typeof text !== 'string') {
    return text;
  }
  return text
    .replace(/and earlier/g, t(`${TP}.earlier`, 'and earlier'))
    .replace(/and later/g, t(`${TP}.later`, 'and later'));
};
